import {Component, Input, Output, EventEmitter} from '@angular/core';
import {EntityLogEntity} from '../../../../entities/log/entity-log.entity';
import {WidgetBase} from '../../widget-base';
import {LogWidgetEventStruct} from '../log-widget-event.struct';
import {DataStreamLogWidgetEnum, DeviceLogWidgetEnum, GatewayLogWidgetEnum, LogWidgetEnum} from '../../../../enums';
import {DataStreamEntityLogEntity, DeviceEntityLogEntity, GatewayEntityLogEntity} from '../../../../entities';

@Component({
  selector: 'data-stream-log-details-widget',
  template: `
    <ng-container [ngSwitch]="entity.data_stream_log_widget_type()">

      <ng-container *ngSwitchCase="DataStreamLogWidgetEnum.DATA_STREAM_LOG_WIDGET__DATA_STREAM">
        <data-stream-fetch-log-details-widget [entity]="entity" [options]="options" [layout]="layout"> </data-stream-fetch-log-details-widget>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <log-details-generic-widget [entity]="entity" [options]="options" [layout]="layout"> </log-details-generic-widget>
      </ng-container>

    </ng-container>
    `
})
export class DataStreamLogDetailsWidgetComponent extends WidgetBase{
  @Input() entity: DataStreamEntityLogEntity = null;
  @Input() options: any = {};
  @Input() layout: string = null;
  @Output() widgetEvent = new EventEmitter<LogWidgetEventStruct>();
  forwardEvent(e, widgetEvent: LogWidgetEventStruct) {
    e.preventDefault()
    this.widgetEvent.emit(widgetEvent);
  }
  public DataStreamLogWidgetEnum = DataStreamLogWidgetEnum;
  public expand = false;
  public expandRaw = false;

  constructor() {
    super();

  }
}
